import React, { memo, useCallback } from 'react'

import { string, bool, func, number } from 'prop-types'

function YouTubeSlide({ externalId, isActiveSlide, onLoad, slideIndex }) {
  const handleLoad = useCallback(() => {
    if (onLoad) {
      onLoad(slideIndex)
    }
  }, [onLoad, slideIndex])

  if (!isActiveSlide) {
    return null
  }

  return (
    <div className="gallery-area-top-carousel__video-wrapper">
      <iframe
        title="youtube-video"
        src={`https://www.youtube-nocookie.com/embed/${externalId}?enablejsapi=1&rel=0&autoplay=1&mute=1`}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        className="gallery-area-top-carousel__video"
        data-video-id={externalId}
        loading="lazy"
        onLoad={handleLoad}
      />
    </div>
  )
}

YouTubeSlide.propTypes = {
  externalId: string.isRequired,
  isActiveSlide: bool.isRequired,
  onLoad: func,
  slideIndex: number,
}

export default memo(YouTubeSlide)
